"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Validation_1 = __importDefault(require("../../../../../Validation"));
var BlDropzone_1 = __importDefault(require("../../../../../FormComponents/BlDropzone"));
var react_i18next_1 = require("react-i18next");
var settingsSlice_1 = require("../../../../../../features/settings/settingsSlice");
var react_redux_1 = require("react-redux");
var globalSlice_1 = require("../../../../../../features/global/globalSlice");
var SkeletonLoading_1 = __importDefault(require("../../../../../SkeletonLoading"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../../../styles.module.scss"));
var FileUploadSection = function (_a) {
    var formikProps = _a.formikProps;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(false), loading = _b[0], setLoading = _b[1];
    var uploadFile = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var uploadedFiles, e_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, dispatch(settingsSlice_1.uploadMedia(files))];
                case 1:
                    uploadedFiles = _a.sent();
                    formikProps.setFieldValue('developerMedia', uploadedFiles);
                    setLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    key = Object.keys(e_1.response.data.errors)[0];
                    dispatch(globalSlice_1.addToastMessage({
                        text: e_1.response.data.errors[key]
                            ? t('ERRORS.' + e_1.response.data.errors[key][0])
                            : t('ERRORS.IMAGE_UPLOAD_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var removeFile = function (id) {
        dispatch(settingsSlice_1.removeMedia(id));
        var filterElement = formikProps.values.developerMedia.filter(function (item) { return item.id !== id; });
        formikProps.setFieldValue('developerMedia', filterElement);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.row, 'sixteen wide computer column') },
        react_1.default.createElement("div", { className: classnames_1.default('sixteen wide mobile sixteen wide tablet sixteen wide computer column', styles_module_scss_1.default.section_field) },
            react_1.default.createElement("label", { className: styles_module_scss_1.default.label_inputs, htmlFor: "developerMedia" },
                react_1.default.createElement("p", null, t('Account.Settings.VIDEOS_OR_IMAGES.LABEL')),
                react_1.default.createElement("p", { className: styles_module_scss_1.default.sub_label },
                    "(",
                    t('Account.Settings.VIDEOS_OR_IMAGES.SUB_LABEL'),
                    ")"),
                react_1.default.createElement(Validation_1.default, { name: "developerMedia", formikProps: formikProps },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(BlDropzone_1.default, { values: formikProps.values.developerMedia, onChange: function (e) {
                                uploadFile(e);
                            }, onRemoved: function (id) {
                                removeFile(id);
                            }, onReordered: function () { }, onReordering: function () { }, loadingElement: loading ? react_1.default.createElement(SkeletonLoading_1.default, null) : null })))))));
};
exports.default = FileUploadSection;
